import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up-light.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down-light.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-3097b6eb")

_pushScopeId("data-v-3097b6eb")
const _hoisted_1 = { class: "text-12px text-gray-lp-300 font-semibold" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "text-16px flex items-center cursor-pointer text-gray-lp-300 font-semibold" }
const _hoisted_4 = { class: "flex items-center ml-2 pointer-events-auto" }
const _hoisted_5 = { style: {"margin-left":"-14px","margin-right":"-14px","width":"399px"} }
const _hoisted_6 = { class: "border-b border-gray-lp-400 px-4 py-2" }
const _hoisted_7 = { class: "inline-flex justify-between" }
const _hoisted_8 = { class: "font-semibold text-14px text-gray-lp-300" }
const _hoisted_9 = { class: "flex flex-col pb-2 gap-1 p-4 text-14px xxl:text-14px text-black-lp-100" }
const _hoisted_10 = { class: "flex flex-row gap-1" }
const _hoisted_11 = { class: "flex flex-grow" }
const _hoisted_12 = { class: "text-1px text-right" }
const _hoisted_13 = { class: "flex flex-grow" }
const _hoisted_14 = { class: "text-1px text-right" }
const _hoisted_15 = { class: "flex flex-grow" }
const _hoisted_16 = { class: "text-right" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "px-4" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_18 = { class: "flex flex-row pb-2" }
const _hoisted_19 = { class: "flex flex-grow text-black-lp-100 text-14px float-left pl-4 pt-2" }
const _hoisted_20 = { class: "text-black-lp-100 text-14px pr-4 float-right text-right pt-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", {
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleTooltip && _ctx.toggleTooltip(...args))),
    class: "pointer-events-none relative flex flex-col py-1 px-2 bg-gray-lp-1000 border border-gray-lp-1400 rounded-lg"
  }, [
    _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('bookingShipment.shipment.chargeableWeight.label')), 1),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.chargeableWeight) + " Kg ", 1),
      _createVNode("div", _hoisted_4, [
        _createVNode("img", {
          alt: "up",
          class: `cursor-pointer ${_ctx.isShow ? '' : 'hidden'} w-3`,
          src: _imports_0
        }, null, 2),
        _createVNode("img", {
          alt: "down",
          class: `cursor-pointer ${_ctx.isShow ? 'hidden' : ''} w-3`,
          src: _imports_1
        }, null, 2)
      ]),
      _createVNode(_component_OverlayPanel, {
        ref: "opTooltip",
        appendTo: "body",
        class: "w-auto",
        unstyled: true
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('bookingShipment.shipment.chargeableWeight.detail')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('bookingShipment.shipment.chargeableWeight.totalItem')), 1),
                _createVNode("div", _hoisted_12, _toDisplayString(_ctx.totalItem), 1)
              ]),
              _createVNode("div", {
                class: `flex flex-row gap-1 ${_ctx.isGrossWeight && !_ctx.isCampaign ? 'text-black-lp-100' : 'text-gray-lp-600'}`
              }, [
                _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('bookingShipment.shipment.chargeableWeight.totalGrossWeight')), 1),
                _createVNode("div", _hoisted_14, _toDisplayString(_ctx.totalGrossWeight) + " kg ", 1)
              ], 2),
              _createVNode("div", {
                class: `flex flex-row gap-1 text-gray-lp-600 ${
                _ctx.isVolumeWeight && !_ctx.isCampaign
                      ? 'text-black-lp-100'
                      : 'text-gray-lp-600'
                  }`
              }, [
                _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('bookingShipment.shipment.chargeableWeight.totalDimensionWeight')), 1),
                _createVNode("div", _hoisted_16, _toDisplayString(_ctx.totalDimensionWeight) + " kg ", 1)
              ], 2)
            ]),
            _hoisted_17,
            _createVNode("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('bookingShipment.shipment.chargeableWeight.label')), 1),
              _createVNode("div", _hoisted_20, _toDisplayString(_ctx.chargeableWeight) + " kg ", 1)
            ])
          ])
        ]),
        _: 1
      }, 512)
    ])
  ], 512)), [
    [_directive_click_outside, () => _ctx.onCloseAnywhere(false)]
  ])
})